import React from 'react';
import Message from 'components/Message';
import Confirm from 'components/Confirm';
import { enableServiceModalMessages as messages } from './ClassList.messages';

const EnableServicePricingModal = () => {
  return (
    <Confirm
      title={<Message message={messages.title} />}
      cancelNode={<Message message={messages.cancel} />}
      acceptNode={<Message message={messages.contactUs} />}
      isOpen>
      <Message message={messages.body} />
    </Confirm>
  );
};

export default EnableServicePricingModal;
